import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/slcp/assessments/$assessmentId/overview',
      params: { assessmentId: params.assessmentId },
    });
  },
});
